import { useMemo } from 'react'
import { useApp } from 'hooks'
import { SortElementsOptions } from 'ts/types'

const initialSortElements: SortElementsOptions = {
  elementList1: [],
  elementList2: [],
  elementList3: [],
  elementList4: []
}

export function useElementOptions() {
  const { sorElements } = useApp()

  return useMemo(() => {
    if (!sorElements) return initialSortElements

    const elementList1 = sorElements.elementList1.map((el) => ({
      label: el.value,
      value: el.value
    }))

    const elementList2 = sorElements.elementList2.map((el) => ({
      label: el.value,
      value: el.value,
      element1Id: el.element1Id
    }))

    const elementList3 = sorElements.elementList3.map((el) => ({
      label: el.value,
      value: el.value,
      element2Id: el.element2Id
    }))

    const elementList4 = sorElements.elementList4.map((el) => ({
      label: el.value,
      value: el.value,
      element3Id: el.element3Id
    }))

    return {
      elementList1,
      elementList2,
      elementList3,
      elementList4
    }
  }, [sorElements])
}
